(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vestiging-google-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Init per kaart. Gebruikt data-more-init i.p.v. eenmalige DOMContentLoaded-scan,
    // omdat de theme-editor kaarten na een instelling-wijziging vervangt via de
    // Section Rendering API (geen volledige page-reload) — een losse DOMContentLoaded-
    // listener zou dan nooit meer opnieuw draaien voor de vervangen/nieuwe kaarten.
    const initCard = (card) => {
      if (card.dataset.moreInit) return;
      card.dataset.moreInit = 'true';

      const text = card.querySelector('.g-review__text');
      const button = card.querySelector('.g-review__more');
      if (!text || !button) return;

      const checkOverflow = () => {
        const isOverflowing = text.scrollHeight > text.clientHeight + 1;
        const shouldShow = isOverflowing || card.classList.contains('g-review--expanded');
        button.classList.toggle('g-review__more--visible', shouldShow);
      };

      button.addEventListener('click', () => {
        const expanded = card.classList.toggle('g-review--expanded');
        button.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;
        checkOverflow();
      });

      // ResizeObserver reageert op latere formaatwijzigingen (fonts die laden,
      // tekst die in de editor live wordt aangepast). Maar de eerste meting bij
      // observe() kan te vroeg vallen (voor fonts geladen zijn) en blijft dan
      // fout staan tot er een échte resize plaatsvindt — vandaar de expliciete
      // vangnet-checks direct na render en zodra fonts geladen zijn.
      new ResizeObserver(checkOverflow).observe(text);
      requestAnimationFrame(checkOverflow);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(checkOverflow);
      }
    };

    const scan = (root) => {
      root.querySelectorAll?.('.g-review').forEach(initCard);
      if (root.matches?.('.g-review')) initCard(root);
    };

    scan(document);

    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scan(node);
        });
      }
    }).observe(document.body, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
